import {
  ClipboardList,
  ExternalLink,
} from "lucide-react";
import { Link } from "react-router-dom";
import "./Survey.css";

function Survey() {

  return (
    <div className="survey-page">
      <div className="survey-header">
        <div className="header-icon">
          <ClipboardList size={28} />
        </div>
        <h1>RF Conference 2026 Feedback</h1>
        <p>Help us improve future conferences by sharing your experience.</p>
      </div>
      <div
        className="external-survey-link"
        style={{ flexDirection: "column", alignItems: "center", gap: "12px" }}
      >


        <Link
          to={"https://bit.ly/BFFConfAskQuestion"}
          className="external-link-btn"
          style={{
            width: "100%",
            maxWidth: "300px",
            justifyContent: "center",
          }}
        >
          <span>Take Survey</span>
          <ExternalLink size={16} />
        </Link>
        <p
          style={{
            fontSize: "0.8rem",
            color: "var(--text-secondary)",
            margin: 0,
            textAlign: "center",
          }}
        >
          Your responses are anonymous and will be used only for improvement
        </p>
      </div>
    </div>
  );
}

export default Survey;
